import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Alert } from '@rd/types';

@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'anz-alert-banner',
  template: `
    <div
      class="flex gap-2 rounded-[4px] border border-solid border-[#add2e4] bg-[#f0faff] px-4 py-3 lg:gap-[10px] lg:py-4">
      <img
        class="mt-[6px] h-4 w-4 flex-shrink-0 lg:mt-1"
        [src]="alert.alertIcon"
        alt="alert-banner-icon" />
      <p class="m-0 text-[#494949]" [innerHTML]="alert.alertDescription"></p>
    </div>
  `,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
})
export class AnzAlertBannerComponent {
  @Input() alert: Alert;
}
